<script setup lang="ts">
import { useStorage } from '@vueuse/core'
// import BaseHeader
import 'virtual:uno.css'
const { theme } = useAppConfig()
const routeObj = useRoute()
const layout = routeObj.meta.layout || 'default'

onMounted(() => {
  const useTheme = useStorage<string | null>('theme', '')
  if (!useTheme.value) {
    useTheme.value = JSON.stringify(theme)
  } else {
    updateAppConfig({ theme: JSON.parse(useTheme.value) })
  }
})
</script>

<template>

    <div class="h-screen overflow-hidden color-[var(--text-color)] bg-[var(--primary-color)]" v-cloak>
      <a-extract-style>
        <a-config-provider :theme="{
          token: {
            colorPrimary: theme.primaryColor
          }
        }">
              <NuxtLayout :name="layout" :transition="{
                name: 'bounce',
                mode: 'out-in'
              }">
                  <template #header>
                    <BaseHeader></BaseHeader>
                  </template>
                  <nuxt-page></nuxt-page>
                  <template #footer>
                    <BaseFooter></BaseFooter>
                  </template>
              </NuxtLayout>
        </a-config-provider>
      </a-extract-style>

    </div>


</template>

<style scoped lang="scss"></style>
